<template>
  <v-menu
    v-model="isOpen"
    width="400px"
    max-height="540px"
    location="bottom end"
    location-strategy="connected"
    scroll-strategy="reposition"
    :close-on-content-click="false"
    class="select-menu"
  >
    <template #activator="{ props }">
      <slot name="activator" :props="props" />
    </template>
    <v-window v-model="windowIndex" class="elevation-1 rounded-lg">
      <v-window-item :value="0">
        <v-card flat class="d-flex flex-column" style="height: 100%; min-height: 540px;">
          <v-card-title class="select-popup-header d-flex justify-space-between align-center">
            <p>Filtros</p>
            <v-btn icon="mdi-close" variant="text" density="compact" @click="closeMenu"></v-btn>
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text class="flex-grow-1 pa-0" style="overflow-y: auto;">
            <v-list>
              <template v-for="category in availableCategories" :key="category.key">
                <v-list-item
                  :title="category.title"
                  :subtitle="getSelectionSummary(category.key)"
                  @click="openCategory(category)"
                  class="item-filter-style"
                >
                  <template v-slot:append>
                    <v-icon>mdi-menu-right</v-icon>
                  </template>
                </v-list-item>
              </template>
            </v-list>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions class="pa-4 d-flex w-100 justify-end">
            <v-btn
              variant="outlined"
              class="px-6 py-5 d-flex"
              rounded="xl"
              :style="{ color: '#505353', borderColor: '#C5C7C6' }"
              @click="clearAndCloseMenu"
            >
              Limpar
            </v-btn>
            <v-btn
              variant="elevated"
              color="primary-60"
              class="px-6 py-5 d-flex elevation-0"
              rounded="xl"
              @click="applyAllFilters"
            >
              Aplicar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-window-item>

      <v-window-item :value="1">
        <v-card class="d-flex flex-column" style="height: 100%; min-height: 540px;">
          <v-card-title class="select-popup-header d-flex justify-space-between align-center pa-2">
            <div class="d-flex align-center">
              <v-btn icon="mdi-arrow-left" variant="text" density="compact" @click="goBackToItems"></v-btn>
              <p class="ml-2" v-if="currentCategory">{{ currentCategory.title }}</p>
            </div>
            <v-btn icon="mdi-close" variant="text" density="compact" @click="closeMenu"></v-btn>
          </v-card-title>
          <v-divider></v-divider>

          <div v-if="currentCategory && !currentCategory.isStatic" class="pa-4">
            <rb-input
              v-model="searchQuery"
              prepend-inner-icon="mdi-magnify" placeholder="Pesquisar"
              hide-details
            ></rb-input>
          </div>

          <v-sheet v-if="!subItemsLoading" class="px-4 d-flex align-center" style="height: 48px;">
            <v-checkbox
              v-model="selectAll"
              label="Selecionar todos"
              hide-details
              density="compact"
              @change="toggleSelectAll"
            ></v-checkbox>
          </v-sheet>
          <v-divider v-if="!subItemsLoading"></v-divider>

          <v-card-text class="flex-grow-1 pa-0" style="overflow-y: auto; position: relative; max-height: 270px;">
            <v-progress-linear
              v-if="subItemsLoading"
              indeterminate
              color="primary"
              absolute
            ></v-progress-linear>
            
            <v-list v-if="!subItemsLoading">
              <v-list-item
                v-for="item in filteredSubItems"
                :key="item.id"
                @click="toggleSelection(item.id)"
              >
                <template v-slot:prepend>
                  <v-checkbox
                    :model-value="tempSelection.has(item.id)"
                    hide-details
                    density="compact"
                    @click.stop="toggleSelection(item.id)"
                  ></v-checkbox>
                </template>
                <v-list-item-title>{{ item.titulo || item.nome }}</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="filteredSubItems.length === 0 && !subItemsLoading">
                <v-list-item-title class="text-center">Nenhum item encontrado.</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card-text>
          
          <v-divider></v-divider>
          <v-card-actions class="pa-4 d-flex w-100 justify-end">
            <v-btn
              variant="outlined"
              class="px-6 py-5 d-flex"
              rounded="xl"
              :style="{ color: '#505353', borderColor: '#C5C7C6' }"
              @click="clearAndCloseSubitens"
            >
              Cancelar
            </v-btn>
            <v-btn
              variant="elevated"
              color="primary-60"
              class="px-6 py-5 d-flex elevation-0"
              rounded="xl"
              @click="saveSubItemSelection"
            >
              Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-window-item>
    </v-window>
  </v-menu>
</template>

<script>
import { Get } from '@/ai_studio/http/http';

export default {
  name: 'MenuComponent',

  props: {
    modelValue: { type: Boolean, default: false },
    initialFilters: { type: Object, default: () => ({}) },
    availableIds: { type: Object, default: () => ({}) },
    showProcessoSeletivo: { type: Boolean, default: false },
    showProcesso: { type: Boolean, default: false},
    showModalidade: { type: Boolean, default: false },
    showNivelEnsino: { type: Boolean, default: false },
    showCurso: { type: Boolean, default: false },
    showOfertaCurso: { type: Boolean, default: false },
    showEtapa: { type: Boolean, default: false },
    showFaixaConversao: { type: Boolean, default: false },
    keepSelectedWhenRestricted: { type: Boolean, default: true },
    hideEmptyCategories: { type: Boolean, default: false },
  },

  emits: ['update:modelValue', 'apply-filters', 'clear-filters'],

  data() {
    return {
      isOpen: false,
      windowIndex: 0,
      currentCategory: null,
      subItems: [],
      subItemsLoading: false,
      searchQuery: '',
      tempSelection: new Set(),
      selectAll: false,
      mainFilters: {},
      categories: [
        { key: 'processoSeletivo', title: 'Processo Seletivo', endpoint: 'assistents/crm/listarProcessosSeletivos' },
        { key: 'processo', title: 'Processo', endpoint: 'listprocess'},
        { key: 'modalidade', title: 'Modalidade', endpoint: 'assistents/crm/listarModalidades' },
        { key: 'nivelEnsino', title: 'Nível de Ensino', endpoint: 'assistents/crm/listarNiveisEnsino' },
        { key: 'curso', title: 'Curso', endpoint: 'assistents/crm/listarCursos' },
        { key: 'ofertaCurso', title: 'Oferta de Curso', endpoint: 'assistents/crm/listarOfertas' },
        { key: 'etapa', title: 'Etapa'},
        { 
          key: 'faixaConversao', 
          title: 'Faixa de Conversão', 
          isStatic: true, 
          items: [
            { id: 'lt60', nome: "Menor que 60" },
            { id: '60-70', nome: "Entre 60 e 70" },
            { id: '70-90', nome: "Entre 70 e 90" },
            { id: 'gt90', nome: "Maior que 90" },
          ]
        },
      ],
      itemsCache: {},
    };
  },

  computed: {
    availableCategories() {
      return this.categories
        .map(c => {
          const propName = 'show' + c.key[0].toUpperCase() + c.key.slice(1);
          return { ...c, show: this[propName] };
        })
        .filter(c => c.show)
        .filter(c => {
          if (!this.hideEmptyCategories) return true;
          const allowed = this.availableIds?.[c.key];
          return !Array.isArray(allowed) || allowed.length > 0;
        });
    },
    
    filteredSubItems() {
      if (!this.searchQuery) {
        return this.subItems;
      }

      const query = this.normalizeText(this.searchQuery);

      return this.subItems.filter(item => {
        const name = item.titulo || item.nome || '';
        return this.normalizeText(name).includes(query);
      });
    },
  },

  watch: {
    modelValue(newVal) {
      if (newVal) {
        this.mainFilters = JSON.parse(JSON.stringify(this.initialFilters || {}));
      }
      this.isOpen = newVal;
    },
    
    isOpen(newVal) {
      if (!newVal && this.modelValue) {
        this.$emit('update:modelValue', false);
      }
      if (!newVal) {
        this.windowIndex = 0;
      }
    },

    tempSelection: {
      deep: true,
      handler() {
        if (this.filteredSubItems.length === 0) {
          this.selectAll = false;
          return;
        }
        this.selectAll = this.filteredSubItems.every(item => this.tempSelection.has(item.id));
      }
    },
    filteredSubItems() {
      if (this.filteredSubItems.length === 0) {
        this.selectAll = false;
        return;
      }
      this.selectAll = this.filteredSubItems.every(item => this.tempSelection.has(item.id));
    },
    availableIds: {
      deep: true,
      handler() {
        if (this.windowIndex !== 1 || !this.currentCategory) return;

        const raw = this.itemsCache[this.currentCategory.key] || [];
        this.subItems = this.applyRestriction(this.currentCategory.key, raw);
      }
    },
  },

  methods: {
    closeMenu() {
      this.isOpen = false;
      this.$emit('update:modelValue', false);
      this.windowIndex = 0;
    },

    getAllowedIdSet(categoryKey) {
      const raw = this.availableIds?.[categoryKey];

      if (!raw || raw === 'all') return null;

      if (!Array.isArray(raw)) return null;

      const ids = raw
        .map(v => (v && typeof v === 'object') ? v.id : v)
        .filter(v => v !== null && v !== undefined && v !== '')
        .map(v => String(v));

      return new Set(ids);
    },

    applyRestriction(categoryKey, items) {
      const allowedSet = this.getAllowedIdSet(categoryKey);
      if (!allowedSet) return items || [];

      const selectedSet = this.keepSelectedWhenRestricted
        ? new Set(Array.from(this.tempSelection || []).map(v => String(v)))
        : null;

      return (items || []).filter(item => {
        const id = item?.id ?? item?.pk;
        const sid = String(id);

        return allowedSet.has(sid) || (selectedSet && selectedSet.has(sid));
      });
    },

    async openCategory(category) {
      this.currentCategory = category;
      this.searchQuery = '';
      this.subItems = [];
      this.subItemsLoading = true;

      const currentIds = this.mainFilters[category.key] || [];
      this.tempSelection = new Set(Array.isArray(currentIds) ? currentIds : []);
      this.selectAll = false;

      if (currentIds === 'all') {
        this.tempSelection = new Set();
        this.selectAll = true;
      } else {
        this.tempSelection = new Set(currentIds);
        this.selectAll = false;
      }

      try {
        let rawItems = null;

        if (category.key === 'etapa') {
          let processos = this.itemsCache.processo;
          if (!processos) {
            const dataProcessos = await Get('listprocess?contexto=1');
            processos = dataProcessos || [];
            this.itemsCache.processo = processos;
          }

          const etapas = [];
          processos.forEach(proc => {
            const processoNome = proc.nome;
            const listaEtapas = proc.etapas || proc.etapas_processo || [];
            listaEtapas.forEach(etapa => {
              etapas.push({
                id: etapa.id,
                nome: `${processoNome} - ${etapa.titulo}`,
                processoId: proc.id,
                processoNome: proc.nome || proc.titulo,
              });
            });
          });

          rawItems = etapas;
          this.itemsCache[category.key] = etapas;
        }
        else if (category.isStatic) {
          rawItems = category.items || [];
          this.itemsCache[category.key] = rawItems;
        }
        else if (this.itemsCache[category.key]) {
          rawItems = this.itemsCache[category.key];
        }
        else {
          const data = await Get(`${category.endpoint}?contexto=1`);
          rawItems = data || [];
          this.itemsCache[category.key] = rawItems;
        }

        this.subItems = this.applyRestriction(category.key, rawItems);

      } catch (error) {
        console.error('Erro ao buscar itens:', error);
        this.subItems = [];
      } finally {
        this.subItemsLoading = false;
        this.windowIndex = 1;
      }
    },

    goBackToItems() {
      this.windowIndex = 0;
      this.currentCategory = null;
      this.searchQuery = '';
      this.tempSelection.clear();
      this.subItems = [];
    },

    clearAndCloseMenu() {
      this.$emit('clear-filters', this.mainFilters)
      this.mainFilters = [];
      this.closeMenu();
    },
    clearAndCloseSubitens() {
      this.goBackToItems();
    },

    saveSubItemSelection() {
      this.mainFilters[this.currentCategory.key] = Array.from(this.tempSelection);
      this.goBackToItems();
    },
    normalizeText(text) {
      return (text || '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
    },

    applyAllFilters() {
      this.$emit('apply-filters', this.mainFilters);
      this.closeMenu();
    },

    getSelectionSummary(categoryKey) {
      const selection = this.mainFilters[categoryKey];

      if (Array.isArray(selection) && selection.length > 0) {
        return `${selection.length} selecionado(s)`;
      }
      return 'Nenhum selecionado';
    },

    toggleSelection(id) {
      if (this.tempSelection.has(id)) {
        this.tempSelection.delete(id);
      } else {
        this.tempSelection.add(id);
      }
    },

    toggleSelectAll() {
      if (this.selectAll) {
        this.filteredSubItems.forEach(item => this.tempSelection.add(item.id));
      } else {
        this.filteredSubItems.forEach(item => this.tempSelection.delete(item.id));
      }
    },
  },
};
</script>

<style scoped>
.filters-menu-component {
  padding: 0 !important;
  border-radius: 8px;
}
.select-popup-header {
  padding-right: 8px !important;
  color: rgb(var(--v-theme-neutral-35));
  background-color: rgb(var(--v-theme-neutral-95));
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  min-height: 56px; 
}
.select-menu:deep(.v-window__container) {
  margin-top: 0 !important;
  height: 100%;
  border-radius: 8px;
}
.item-filter-style {
  display: flex;
  height: 72px;
  min-height: 72px;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
}
</style>